module.exports = __webpack_public_path__ + "media/images/desktop2/2008_AP080907030763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/desktop2/2008_AP080907030763.jpg
// module id = 22
// module chunks = 0